import React, { useState, useEffect } from "react";
import { motion, animate, useMotionValue, useTransform } from "framer-motion";

export default function SVGMorph({ paths, duration = 0.4, delay = 0.5 }) {
  const [pathIndex, setPathIndex] = useState(0);
  const progress = useMotionValue(pathIndex);

  const arrayOfIndex = paths.map((_, i) => i);
  const path = useTransform(progress, arrayOfIndex, paths);

  useEffect(() => {
    const animation = animate(progress, pathIndex, {
      duration: duration,
      ease: "easeInOut",
      delay: delay,
      onComplete: () => {
        if (pathIndex === paths.length - 1) {
          progress.set(0);
          setPathIndex(1);
        } else {
          setPathIndex(pathIndex + 1);
        }
      },
    });
    return () => {
      animation.stop();
    };
  }, [pathIndex]);

  return <motion.path stroke="white" strokeWidth="2" d={path} />;
}
